module.exports = __webpack_public_path__ + "assets/img/logo_rehub.b89ae8dd.png";